<template>
  <div
    ref="dom"
    class="charts chart-bar"
    style="width: 100%; height: 650px"
  ></div>
</template>

<script>
import echarts from "echarts";
import { on, off } from "@/libs/tools";

export default {
  name: "ChartBar",
  props: {
    timestampsLine: Array,
    dianliuLine: Array,
    dianliuLine1: Array,
    shengyurongliangLine: Array,
    yachaLine: Array,
    zongdianyaDataLine: Array,
    chongdianDataLine: Array,
    fangdianDataLine: Array,
    moswendu: Array,
    huanjingwendu: Array,
    NTC4: Array,
    NTC3: Array,
    NTC2: Array,
    NTC1: Array,
    alarm_str: Array,
    chongdianmos: Number,
    fangdianmos: Number,
    mosState: Object,
  },
  data() {
    return {
      dom: null,
    };
  },
  methods: {
    resize() {
      this.dom.resize();
    },

    // 获取报警点数据 - 在x轴上标记报警位置
 getAlarmPoints() {
  if (!this.alarm_str || !this.timestampsLine) return [];

  const alarmPoints = [];
  this.alarm_str.forEach((alarm, index) => {
    if (alarm && this.zongdianyaDataLine[index] !== undefined) { // 检查 index 合法性
      const yValue = 0; // 示例计算
      const timestamp = this.timestampsLine[index];

      // 根据 alarm 的状态设置颜色
      let color;
      if (alarm.web_flag_gz === 1) {
        color = 'red';
      } else if (alarm.web_flag_gz === 2) {
        color = 'yellow';
      } else {
        color = '#ECF004'; // 默认颜色
      }

      alarmPoints.push({
        name: timestamp,
        value: [timestamp, yValue],
        alarmInfo: alarm, // 存储报警信息
        color: color // 将颜色纳入报警点数据中
      });
    }
  });
  console.log('Alarm Points:', alarmPoints); // 记录报警点信息
  return alarmPoints;
},
    setChartOptions() {

      // 生成报警点数据
      const alarmPoints = this.getAlarmPoints();

      const option = {
    tooltip: {
  trigger: "axis",
  axisPointer: {
    animation: false,
  },
  formatter: (params) => {
        const timeIndex = params[0].dataIndex;
        const time = this.timestampsLine[timeIndex];
        let tooltipContent = `<div class="custom-tooltip">${time}<br/>`;

        params.forEach((param) => {
          if (param.seriesName !== '报警点') {
            tooltipContent += `
              <span style="display:inline-block;width:10px;height:10px;background-color:${param.color};margin-right:5px;border-radius: 5px;"></span>
              ${param.seriesName}: ${param.data}<br/>
            `;
          }
        });

        // 添加MOS状态
        const mosOff = this.mosState.chongdianmos == 1 ? this.$t('开启') : this.$t('关闭');
        tooltipContent += `${this.$t('充电MOS')}: ${mosOff}<br/>`;
        const mosOn = this.mosState.fangdianmos == 1 ? this.$t('开启') : this.$t('关闭');
        tooltipContent += `${this.$t('放电MOS')}: ${mosOn}<br/>`;

        // 添加报警信息
        const currentAlarm = this.alarm_str[timeIndex];
        if (currentAlarm) {
          const color = (currentAlarm.web_flag_gz === 1) ? 'red' : (currentAlarm.web_flag_gz === 2) ? 'yellow' : 'transparent';
          tooltipContent += `
            <span style="display:inline-block;width:10px;height:10px;background-color:${color};margin-right:5px;border-radius: 5px;"></span>
            ${currentAlarm.alarm_str}<br/>
          `;
        }

        tooltipContent += `</div>`;
        return tooltipContent;
  },
},
        legend: {
          data: [
            this.$t('SOC')+"(%)",
            this.$t('电压')+"(V)",
            this.$t('充电电流'),
            this.$t('放电电流'),
            this.$t('压差')+"(mV)",
            this.$t('MOS温度')+"(℃)",
           this.$t('环境温度')+ "(℃)",
            this.$t('NTC1')+"(℃)",
            this.$t('NTC2')+"(℃)",
            this.$t('NTC3')+"(℃)",
            this.$t('NTC4')+"(℃)",
          ],
          orient: "vertical",
          right: "00px",
          top: "50px",
          itemGap: 10,
        },
        axisPointer: {
          link: [{ xAxisIndex: "all" }],
        },
        dataZoom: [
          {
            show: false,
            realtime: true,
            start: 0,
            end: 100,
            xAxisIndex: [0, 1],
            handleStyle: {
              color: "#fff",
              borderColor: "black",
            },
            fillerColor: "rgba(0, 0, 0, 0)",
          },
          {
            type: "inside",
            realtime: true,
            start: 0,
            end: 100,
            xAxisIndex: [0, 1],
          },
        ],
        grid: [
          { left: 60, right: 150, height: "35%" },
          { left: 60, right: 150, top: "55%", height: "35%" },
        ],
        xAxis: [
          {
            type: "category",
            axisLine: { onZero: true },
            data: this.timestampsLine,
            offset: 20,
            axisLine: {
              lineStyle: {
                color: "rgba(127, 132, 139, 1)",
              },
            },
            axisLabel: {
              color: "rgba(127, 132, 139, 1)",
            },
          },
          {
            gridIndex: 1,
            type: "category",
            axisLine: { onZero: true },
            data: this.timestampsLine,
            position: "top",
            show: true,
            offset: 22,
            axisLine: {
              lineStyle: {
                color: "rgba(127, 132, 139, 1)",
              },
            },
            axisLabel: {
              color: "rgba(127, 132, 139, 1)",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "rgba(127, 132, 139, 0)",
              },
            },
            axisLabel: {
              color: "rgba(127, 132, 139, 1)",
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#ccc",
              },
            },
          },
          {
            gridIndex: 1,
            type: "value",
            inverse: true,
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#ccc",
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(127, 132, 139, 0)",
              },
            },
            axisLabel: {
              color: "rgba(127, 132, 139, 1)",
            },
          },
        ],
        series: [
          {
            name: this.$t('电压')+"(V)",
            type: "line",
            symbolSize: 8,
            data: this.zongdianyaDataLine,
            itemStyle: { color: "rgba(255, 154, 46, 1)" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name: this.$t('SOC')+"(%)",
            type: "line",
            symbolSize: 8,
            data: this.shengyurongliangLine,
            itemStyle: { color: "rgba(25, 190, 107, 1)" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name: this.$t('充电电流'),
            type: "line",
            symbolSize: 8,
            data: this.dianliuLine,
            itemStyle: { color: "rgba(45, 140, 240, 1)" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name: this.$t('放电电流'),
            type: "line",
            symbolSize: 8,
            data: this.dianliuLine1,
            itemStyle: { color: "rgba(247, 114, 52, 1)" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name:  this.$t('MOS温度')+"(℃)",
            type: "line",
            symbolSize: 8,
            data: this.moswendu,
            itemStyle: { color: "#8D4EDA" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name:this.$t('环境温度')+"(℃)",
            type: "line",
            symbolSize: 8,
            data: this.huanjingwendu,
            itemStyle: { color: "#9FBD1D" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name: this.$t('NTC1')+"(℃)",
            type: "line",
            symbolSize: 8,
            data: this.NTC1,
            itemStyle: { color: "#E13EDB" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name: this.$t('NTC2')+"(℃)",
            type: "line",
            symbolSize: 8,
            data: this.NTC2,
            itemStyle: { color: "rgba(240, 139, 180, 1)" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name: this.$t('NTC3')+"(℃)",
            type: "line",
            symbolSize: 8,
            data: this.NTC3,
            itemStyle: { color: "rgba(150, 97, 188, 1)" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name: this.$t('NTC4')+"(℃)",
            type: "line",
            symbolSize: 8,
            data: this.NTC4,
            itemStyle: { color: "rgba(101, 120, 155, 1)" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          {
            name: this.$t('压差')+"(mV)",
            type: "line",
            xAxisIndex: 1,
            yAxisIndex: 1,
            symbolSize: 8,
            data: this.yachaLine,
            itemStyle: { color: "rgba(14, 197, 192, 1)" },
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
          },
          // 添加报警点系列 - 显示黄色圆点
           {
        name: '报警点',
        type: 'scatter',
        xAxisIndex: 0,
        yAxisIndex: 0,
        data: alarmPoints.map(point => ({
          name: point.name,
          value: point.value,
          alarmInfo: point.alarmInfo,
          itemStyle: {
            color: point.color // 使用动态颜色
          }
        })),
        symbolSize: 12, // 稍大一点，更显眼
        zlevel: 10
      }
        ],
      };

      this.dom.setOption(option);
    },
  },
  mounted() {
    this.dom = echarts.init(this.$refs.dom);
    this.setChartOptions();
    on(window, "resize", this.resize);
  },
  watch: {
    timestampsLine() {
      this.setChartOptions();
    },
    dianliuLine() {
      this.setChartOptions();
    },
    shengyurongliangLine() {
      this.setChartOptions();
    },
    yachaLine() {
      this.setChartOptions();
    },
    zongdianyaDataLine() {
      this.setChartOptions();
    },
    chongdianDataLine() {
      this.setChartOptions();
    },
    fangdianDataLine() {
      this.setChartOptions();
    },
    alarm_str() {
      this.setChartOptions();
    },
  },
  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>

<style>
.charts {
}
.custom-tooltip {
  max-width: 200px; /* 设置最大宽度 */
  white-space: normal; /* 允许换行 */
  word-wrap: break-word; /* 允许单词换行 */
}
</style>
